@if (facade.isLoading()) {
<div class="d-flex flex-grow-1 justify-content-center align-items-center">
    <av-loading-item icon="badge" textKey="app.reports.m365_license.loading" />
</div>
} @else {
<div class="reports-page px-2 pt-3 pb-2">
    <div class="d-flex justify-content-end mb-3">
        <button mat-flat-button color="primary" (click)="exportAllCsv()">
            <mat-icon>download</mat-icon>
            {{ 'app.reports.m365_license.export_all_csv' | translate }}
        </button>
    </div>

    <!-- Tenant-wide section -->
    <section class="report-section tenant-wide-section mb-4">
        <div class="d-flex align-items-center gap-2 section-heading mb-3">
            <mat-icon>domain</mat-icon>
            <span>{{ 'app.reports.m365_license.tenant_wide_heading' | translate }}</span>
        </div>

        <div class="row g-3 mb-3">
            <div class="col-12 col-md-4">
                <app-report-kpi-tile icon="inventory_2" labelKey="app.reports.m365_license.total_seats"
                    [value]="totalSeatsValue()" severity="neutral" (tileClick)="openSection('subscriptionOverview')" />
            </div>
            <div class="col-12 col-md-4">
                <app-report-kpi-tile icon="speed" labelKey="app.reports.m365_license.utilization"
                    [value]="utilizationDisplay()" severity="info" (tileClick)="openSection('subscriptionOverview')" />
            </div>
            <div class="col-12 col-md-4">
                <app-report-kpi-tile icon="event_seat" labelKey="app.reports.m365_license.available_seats"
                    [value]="availableSeatsValue()" severity="neutral" (tileClick)="openSection('subscriptionOverview')" />
            </div>
        </div>

        @if (facade.expiringSubscriptions().length > 0) {
        <div class="expiring-alert-strip d-flex align-items-center gap-2 mb-3" (click)="openSection('subscriptionOverview')">
            <mat-icon>schedule</mat-icon>
            <span>{{ 'app.reports.m365_license.expiring_subscriptions_title' | translate }}</span>
            <span class="expiring-count">{{ facade.expiringSubscriptions().length }}</span>
        </div>
        }

        <div class="row g-3">
            <div class="col-12">
                <app-report-chart-card titleKey="app.reports.m365_license.subscription_utilization_chart"
                    [options]="subscriptionUtilizationBarOptions()" (segmentClick)="onSubscriptionBarSegmentClick($event)" />
            </div>
        </div>
    </section>

    <mat-divider class="mb-4" />

    <!-- Scoped assignments section -->
    <section class="report-section scoped-section">
        <div class="d-flex align-items-center justify-content-between section-heading mb-3">
            <div class="d-flex align-items-center gap-2">
                <mat-icon>badge</mat-icon>
                <span>{{ 'app.reports.m365_license.scoped_heading' | translate }}</span>
            </div>
            <button mat-stroked-button (click)="openSection('licenseAssignments')">
                {{ 'app.reports.m365_license.view_all_assignments' | translate }}
            </button>
        </div>

        <div class="row g-3">
            <div class="col-12 col-md-4">
                <app-report-kpi-tile icon="person_off" labelKey="app.reports.m365_license.wasted_seats"
                    [value]="facade.wastedSeats()" [severity]="wastedSeatsSeverity()"
                    (tileClick)="openSection('reclaimableLicenses')" />
            </div>
            <div class="col-12 col-md-8">
                <app-report-chart-card titleKey="app.reports.m365_license.assignment_type_chart"
                    [options]="assignmentTypeDonutOptions()" (segmentClick)="onDonutSegmentClick($event)" />
            </div>
        </div>
    </section>
</div>
}
